import ConfigureCadenceStep from './configureCadence.view';

export default ConfigureCadenceStep;
